import React from 'react'

import BackTop from 'antd/lib/back-top'
import {
  SvgService,
  SvgArrowup
} from '../Svg'
import styles from './index.module.less'
if (__isBrowser__) {
  require('antd/lib/back-top/style/index.css')
}

const FixedBar = () => {
  return (
    <div className={styles.fixed_bar}>
      <a target='_blank' href='//sky.vip.youku.com/bwsvip/136/c5597b1a?wh_ttid=pc

'><SvgService /></a>
      <BackTop visibilityHeight={600} >
        <SvgArrowup />
      </BackTop>
    </div>
  )
}
export default FixedBar
